export const costFilter = amount => {
  return amount ? amount : 0;
};
